import { render, staticRenderFns } from "./SelectCustFields.vue?vue&type=template&id=35ae1c50&scoped=true&"
import script from "./SelectCustFields.vue?vue&type=script&lang=js&"
export * from "./SelectCustFields.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustFields.vue?vue&type=style&index=0&id=35ae1c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae1c50",
  null
  
)

export default component.exports